var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.proofLoginStatus)?_c('div',{staticClass:"content_dashboard"},[_c('h1',{staticClass:"accountcustom"},[_vm._v("Empfangsportal")]),_vm._v(" "),(_vm.summaryerror)?_c('div',{staticClass:"woocommerce-error",attrs:{"role":"alert"}},[_vm._v("Fehler. "+_vm._s(_vm.summaryerrordescription))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"activateFormular"},[_vm._v("\n \t\ttest\n\t")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-351d2859","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoAccess.vue
// module id = 271
// module chunks = 0